import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface AlertModel {
    title: string;
    message: string;
}

@Component({
    selector: 'ep-alert-dialog',
    templateUrl: './alert-dialog.component.html',
    standalone: false
})
export class AlertDialogComponent {
    @Input() title: string;
    @Input() message: string;
    @Input() btnOkText: string;

    @Output() confirm: EventEmitter<void> = new EventEmitter();
    @Output() cancel: EventEmitter<void> = new EventEmitter();
}
